<template>
<div class="unit-denominators">
  <denom-table :header="header" v-model="model"
               :columns="columns" :checker="checker"
               :optional="optional" :code="code" :module="module"
               @progress="progress">
  </denom-table>
</div>
</template>
<script>
import denomTable from '@/sui/components/denomTable'

export default {
  name: 'unit-denominators',

  props: {
    header: {
      type: Boolean,
      default: true
    },

    value: {
      required: true,
      type: Object
    },

    columns: {
      required: true,
      type: Array
    },

    checker: {
      type: Function,
      default: () => { return () => {} }
    },

    optional: {
      type: Boolean,
      default: false
    },

    code: {
      type: String,
      required: true
    },

    module: {
      type: String,
      required: true
    }
  },

  data: function () {
    return {
      model: this.value
    }
  },

  watch: {
    model: {
      handler: function (v) {
        this.$emit('input', v)
      },
      deep: true
    },

    value: {
      handler: function (v) {
        this.model = v
      },
      deep: true
    }

  },

  methods: {
    progress: function (counts) {
      this.$emit('progress', counts)
    }
  },

  components: {
    'denom-table': denomTable
  }
}
</script>
<style scoped lang="less">
</style>
